import {
  all,
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import { request } from 'utils/request';
import { IRestApiResponse } from 'interfaces';
import { selectEnterprise } from 'base/core/selectors';
import { mediaModalActions } from './slice';
import API from './constants';
import { IFilterStateAction } from './interface';

export function* fetchMediaGenerator({ payload }: IFilterStateAction): any {
  try {
    const enterprise = yield select(selectEnterprise);
    const response: IRestApiResponse = yield call(
      request,
      {
        path: `${API.GET_FETCH_MEDIA.path}/${enterprise.id}?keyword=${payload.keyword}&page=${payload.page}&limit=${payload.limit}&type=${payload.type}&sortBy=uploaded`,
        method: API.GET_FETCH_MEDIA.method,
      },
      null,
      true,
    );
    if (response.statusCode === 200) {
      yield put(mediaModalActions.fetchMediaSucceeded(response.data));
    } else {
      yield put(mediaModalActions.fetchMediaFailed());
    }
  } catch (error) {
    yield put(mediaModalActions.fetchMediaFailed());
  }
}

export function* mediaModalSaga() {
  yield all([takeEvery(mediaModalActions.fetchMedia.type, fetchMediaGenerator)]);
}

export default mediaModalSaga;
